/**
 * @deprecated Use a Spacing value from @persona-id/design-tokens
 */
export const BASE = 8;
